import { getFigmaNodeEditState } from '../Nodes/FigmaNode/figmaNodeUndoPreview';
import type { BaseNodeData } from '@/types/node';
import type { EditState, NodeKind } from 'web';

type UpdateNodeEditState = Extract<EditState, { type: 'update_node' }>;

type UpdateNodeUndoTransform = (
  editState: UpdateNodeEditState,
  getCurrentData: (nodeId: string) => BaseNodeData | undefined,
) => EditState;

/** Node-kind-specific transforms for wasm `update_node` undo/redo. Add an entry to support another kind. */
const UPDATE_NODE_UNDO_TRANSFORMS: Partial<Record<NodeKind['type'], UpdateNodeUndoTransform>> = {
  figma_node: (editState, getCurrentData) =>
    getFigmaNodeEditState(editState, (nodeId) => getCurrentData(nodeId)),
};

/**
 * Apply node-kind transforms to wasm undo `EditState`s.
 */
export function applyUpdateNodeUndoTransforms(
  editStates: EditState[],
  getCurrentData: (nodeId: string) => BaseNodeData | undefined,
): EditState[] {
  return editStates.map((editState) => {
    if (editState.type !== 'update_node') return editState;
    const transform = UPDATE_NODE_UNDO_TRANSFORMS[editState.node.kind.type];
    return transform?.(editState, getCurrentData) ?? editState;
  });
}
